import React from "react";

const Context = React.createContext();

export class QuoteSpinnerProvider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      quotePreparing: false,
      text: "",
      selectedQuoteId: null,
      updateFunction: null,
    };
  }

  startBouncing = (text, selectedQuote) => {
    this.setState({
      quotePreparing: true,
      text: text,
      selectedQuoteId: selectedQuote,
    });
  };

  stopBouncing = () => {
    this.setState({
      quotePreparing: false,
      text: "",
      selectedQuote: null,
      updateFunction: null,
    });
  };

  setUpdateFunction = (func) => this.setState({ updateFunction: func });

  fireUpdateFunction = () => {
    this.state.updateFunction && this.state.updateFunction();
  };

  render() {
    const {
      state,
      startBouncing,
      stopBouncing,
      setUpdateFunction,
      fireUpdateFunction,
      props: { children },
    } = this;

    return (
      <Context.Provider
        value={{
          ...state,
          startBouncing,
          stopBouncing,
          setUpdateFunction,
          fireUpdateFunction,
        }}
      >
        {" "}
        {children}
      </Context.Provider>
    );
  }
}

export const QuoteSpinnerConsumer = Context.Consumer;
